<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button v-if="companyLayout" :disabled="!companyLayout.permission.createEngagementStages" @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_engagementStages_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        :data="tableData"
                        :empty-text="$t('general_noData')"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            :label="$t('settings_engagementStages_name')">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            :label="$t('settings_engagementStages_createDate')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            width="150"
                            :label="$t('settings_engagementStages_operations')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.updateEngagementStages"
                                    @click="openModalAdd('update', scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    v-if="companyLayout"
                                    :disabled="!companyLayout.permission.deleteEngagementStages"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- add -->
        <sweet-modal blocking :title="`${$t('settings_engagementStages_add')} ${btnText}`" ref="openModal"  class="modal" v-on:close="closeModal">

            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="$t('settings_engagementStages_stageName')" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- edit -->
        <sweet-modal blocking :title="`${$t('settings_engagementStages_edit')} ${btnText}`" ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">

            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="$t('settings_engagementStages_stageName')" v-model="formEdit.name"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                    <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!--<sweet-modal blocking ref="confirmation" :title="`Delete ` + btnText">-->
            <!--Are you sure you want to delete this {{btnText}}?-->
            <!--<template slot="box-action">-->
                <!--<el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;-->
            <!--</template>-->
        <!--</sweet-modal>-->
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment');
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'engagement-stages',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mounted(){

    },
    data() {
      return {
        paleceholderText: this.$i18n.t('settings_stage'),
        btnText:this.$i18n.t('settings_stage'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        state: 'companyStages',
        form:{
          name: ''
        },
        formEdit:{
          name: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(state){
        let loader = this.$loading.show();
        this.state = state;
        if(state === 'companyStages') {
          this.btnText = 'Stage';
          this.paleceholderText = 'Stage'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, index, row) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/directories?companyId=${this.$route.query.companyId}&operation=${operation}`)
          .then(response => {
            if(operation === 'create'){
              this.form.nameList = response.data.businessUnitTypeNameList;
              this.$refs.openModal.open()
            }else if(operation === 'update'){
              this.formEdit.nameList = response.data.businessUnitTypeNameList;
              this. handleEdit(index, row)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      openModalEdit(){

      },
      openModalDelete(){

      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              name: this.form.name
            };
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification(this.$t('modal_settings_success'), `${this.$t('settings_engagementStages_add')} ${this.btnText}`, "success");
                this.$refs.openModal.close();
                this.loadList(this.state)
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        // this.form.no = ''
        this.form.name = '';
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        // this.formEdit.no = ''
        this.formEdit.name = '';
        this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        this.selectedRowId = row.id;
        let loader = this.$loading.show();
        let Id = 'engagementStageId';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/item?companyId=${this.$route.query.companyId}&${Id}=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open();
            this.formEdit.name = response.data.item.name
            loader.hide()
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              name: this.formEdit.name,
            }
            let loader = this.$loading.show();
            let Id = 'engagementStageId'
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${this.state}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, data)
              .then(response => {
                this.notification(this.$t('modal_settings_success'), `${this.$t('settings_engagementStages_edit')} ${this.btnText}`, "success");
                this.$refs.openModalEdit.close();
                this.loadList(this.state);
                loader.hide()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm(this.$t('settings_engagementStages_ThisWillPermanentlyDeleteTheTemplatesContinue'), this.$t('settings_engagementStages_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });

          let Id = 'engagementStageId';
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.loadList(this.state)
              this.notification(this.$t('modal_settings_success'), this.$t('settings_engagementStages_deleteEngagementStages'), "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      deleteConfirm(){
        let Id = 'engagementStageId'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
          .then(response => {
            // this.$refs.confirmation.close()
            this.loadList(this.state)
            this.notification(this.$t('modal_settings_success'), this.$t('settings_engagementStages_deleteEngagementStages'), "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      tableData(val){
        val.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('DD MMM YYYY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
    .modal {
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: right;
        }
    }
</style>

<style>

</style>
